export default "__VITE_ASSET__OOStFLhF__"